module.exports = __webpack_public_path__ + "img/icon-warning-triangle.99650212.svg";